import React, {
    createRef,
    FC,
    useEffect,
    useRef,
    useState,
    useReducer,
    useCallback,
    useMemo,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import type { RadioChangeEvent } from 'antd'
import { FormInstance, useWatch } from 'antd/es/form/Form'
import type { RcFile, UploadFile, UploadProps } from 'antd/es/upload/interface'
import {
    Button,
    DatePicker,
    Form,
    Input,
    Select,
    Space,
    Switch,
    Typography,
    notification,
    Spin,
    Upload,
    List,
    TimePicker,
    Radio,
    Popover,
    Image,
} from 'antd'
import {
    CheckCircleOutlined,
    UploadOutlined,
    DownloadOutlined,
    DeleteOutlined,
    CloseCircleOutlined,
    PlusCircleOutlined,
    QuestionCircleOutlined,
} from '@ant-design/icons'
import 'moment/locale/zh-cn'
import locale from 'antd/es/date-picker/locale/zh_CN'
import moment, { Moment } from 'moment'
import PageBreadcrumb from '@/components/pageBreadcrumb'
import NoSpaceInput from '@/components/noSpaceInput'
import { IAppState } from '@/store/reducers'
import { getWorkgroup } from '@/store/actions/tableEdit.action'
import type { Descendant } from 'slate'
import DSlate, { DefaultPlugin } from '@dslate/dslate'
import type { DSlateRef } from '@dslate/core'
import { ConfigProvider, defaultConfig } from '@dslate/core'
import { debounce, downloadFile, getUuid } from '@/utils/util'
import { handleTrim, serialize } from '@/pages/table2Mana/table2Edit'
import { getErrorStr } from '@/store/sagas/table.saga'
import { requestFail } from '@/store/actions/common.action'
import {
    addOnlineReview,
    delFile,
    editOnlineReview,
    getFile,
    getOnlineReviewById,
    getWorkDateDiff,
    getWorkgroupLeader,
    relevantGetById,
    uploadFile,
    getOrgRoleUsers,
} from '@/services/progress.service'
import { IAddOnlineReviewData } from '@/store/models/process.model'
import { UploadAPI } from '@/config'
import _ from 'lodash'
import SelectBU from '@/components/selectBU'
import SelectRelatedResponsible from '@/components/selectRelatedResponsible'
import { IBu, IPerson } from '@/store/models/auth.model'
import { RoleCont } from '@/store/constant/auth.constant'
// 选择提案
import SelectProposalListPop from '@/pages/techChangeStatus/components/selectProposalListPop'
// 选择课题
import SelectTechListPop from '@/pages/techChangeStatus/components/selectTechListPop'
import FeedbackTable from '@/pages/processMana/components/feedbackTable'
import SelectUser from '@/components/selectUser'
import SelectUserOfIdName from '@/components/selectUserOfIdName'
import { IWorkgroup } from '@/store/models/tableEdit.model'
import Nav from '@/components/nav'
import TechReviewImg from '@/assets/images/techReview.jpg'
import { validateAuth } from '@/utils/auth'
import { useForm } from 'antd/lib/form/Form'



const plugs = { ...DefaultPlugin }
// 删除图片工具
Reflect.deleteProperty(plugs, 'ImgPlugin')

const ShowSelectTechListPop = 'showSelectTechListPop'
const HideSelectTechListPop = 'hideSelectTechListPop'
const SetSelectTechList = 'setSelectTechListPop'
const DelSelectTechList = 'delSelectTechList'
const SetReviewType = 'setReviewType'
const SetReviewHistory = 'setReviewHistory'
const SetITMTRelevant = 'setITMTRelevant'
const SetTMTJudge = 'setITMTJudge'
const SetBuList = 'setBuList'
const ShowSelectProposalPop = 'showSelectProposalPop'
const HideSelectProposalPop = 'hideSelectProposalPop'
const SetProposal = 'setProposal'

const initialState = {
    showSelectTechListPop: false,
    allSelectTechObj: [],
    reviewType: null,
    reviewHistory: null,
    itmtRelevant: null,
    tmtJudge: null,
    buList: null,
    proposalList: null,
}
const reducer = (state: any, action: { type: string; payload?: any }) => {
    const { type, payload } = action
    let arr = []
    switch (type) {
        case ShowSelectTechListPop:
            return {
                ...state,
                showSelectTechListPop: true,
            }
        case HideSelectTechListPop:
            return {
                ...state,
                showSelectTechListPop: false,
            }
        case SetSelectTechList:
            return {
                ...state,
                showSelectTechListPop: false,
                allSelectTechObj: payload,
            }
        case DelSelectTechList:
            arr = state.allSelectTechObj.filter(
                (item: any) => item.techProject.id !== payload.techProject.id
            )
            return {
                ...state,
                allSelectTechObj: [...arr],
            }
        case SetReviewType:
            return {
                ...state,
                reviewType: payload,
            }
        case SetReviewHistory:
            return {
                ...state,
                reviewHistory: payload,
            }
        case SetITMTRelevant:
            return {
                ...state,
                itmtRelevant: payload,
            }
        case SetTMTJudge:
            return {
                ...state,
                tmtJudge: payload,
            }
        case SetBuList:
            return {
                ...state,
                buList: payload,
            }
        // 选择提案
        case ShowSelectProposalPop:
            return {
                ...state,
                showSelectProposalPop: true,
            }
        case HideSelectProposalPop:
            return {
                ...state,
                showSelectProposalPop: false,
            }
        case SetProposal:
            return {
                ...state,
                selectProposal: payload,
                showSelectProposalPop: false,
            }
    }
}

const AddTechReview: FC = () => {
    const history = useHistory()
    const locationObj = useLocation()
    const dispatch = useDispatch()
    const { t, i18n } = useTranslation()
    const workgroupList = useSelector(
        (state: IAppState) => state.tableEditData.workgroupList
    )
    const authInfo = useSelector((state: IAppState) => state.auth.authInfo)
    const userInfo = useSelector((state: IAppState) => state.auth.userInfo)
    const { Option } = Select
    const { Text } = Typography

    // 添加组件挂载状态检查
    const isMountedRef = useRef(true)

    const [selectionKey, setSelectionKey] = useState<any[]>([])
    const [selectRecord, setSelectRecord] = useState<any>()

    const [loaded, setloaded] = useState(false)
    const [selWorkgroup, setSelWorkgroup] = useState<IWorkgroup | null>(null)
    // const [selTecCert, setSelTecCert] = useState<number | undefined>()

    const [formObj, setFormObj] = useState<
        | (IAddOnlineReviewData & {
            parentId?: string;
            id?: number;
            parentTech?: string;
            productFunction?: string;
            techScope?: string;
            techPerformance?: string;
            techSource?: string;
            firstUseDate?: Moment;
            isPlReview?: boolean;
            techLeaders?: string[];
            coreMembers?: string[];
            generalMembers?: string[];
            technologyContribution?: number | null;
            technologyLeadership?: number | null;
            coreTechnology?: number | null;
        })
            | null
            >(null)
    const [fileList, setFileList] = useState<
        (UploadFile & {
            url?: string;
            fileId?: number;
            status?: string;
        })[]
            >([])
    const [fileIds, setFileIds] = useState<number[]>([])
    const [uploading, setUploading] = useState(false)
    const [form] = useForm()
    const techCertification = Form.useWatch('technologyCertification', form)
    const isCommunicate = Form.useWatch('isCommunicate', form)

    // 时间选择起始
    const [selectStartDate, setSelectStartDate] = useState<any>(null)
    // 当前选择的是 devSubject | devCostAttr
    const [curSelectType, setCurSelectType] = useState('')
    // 开发责任主体
    const [devSubject, setDevSubject] = useState<IBu[]>([])
    // 开发费用归属
    const [devCostAttr, setDevCostAttr] = useState<IBu[]>([])
    // 业务相关责任人
    const [relatedResponsiblePersons, setRelatedResponsiblePersons] = useState<
        IPerson[]
    >([])
    const [isEdit, setIsEdit] = useState(false)
    const [isRelevantRes, setIsRelevantRes] = useState(false)
    const [loading, setLoading] = useState(false)
    // 富文本编辑器key
    // 提案申请相关性反馈
    const [editorKey, setEditorKey] = useState('1')
    const [editor1Key, setEditor1Key] = useState('1_1')
    const [leaders, setLeaders] = useState<any[]>([])


    const [standardOutputValue, setStandardOutputValue] = useState<Descendant[]>([
        {
            type: 'paragraph',
            children: [{ text: '' }],
        },
    ])
    // 选择BU或CT清单
    const [showSelectBu, setShowSelectBu] = useState(false)
    const [showSelectBu2, setShowSelectBu2] = useState(false)
    // 业务相关责任人
    const [showSelectPerson, setShowSelectPerson] = useState(false)
    const [showSelectUser, setShowSelectUser] = useState(false)
    const [hasOffline, setHasOffline] = useState(false)
    const [stateR, dispatchR] = useReducer(reducer, initialState)
    const {
        allSelectTechObj,
        reviewType,
        reviewHistory,
        itmtRelevant,
        tmtJudge,
        selectProposal,
    } = stateR
    // const [switchKey, setSwitchKey] = useState(0)
    // const onSelectRelevant = (e: RadioChangeEvent) => {
    //     setSwitchKey(e.target.value)
    // }
    const formRef = createRef<FormInstance>()

    // 富文本编辑器 内容
    // const [descriptionValue, setDescriptionValue] = useState<Descendant[]>([
    //     {
    //         type: 'paragraph',
    //         children: [{ text: '' }],
    //     },
    // ])
    const descriptionValue = Form.useWatch('description', form) || [
        {
            type: 'paragraph',
            children: [{ text: '' }],
        },
    ]
    // 富文本编辑器
    const editorRef = useRef<DSlateRef>(null)
    const editor2Ref = useRef<DSlateRef>(null)
    const uploadFileLs = useRef<RcFile[]>([])
    const fileListRef = useRef<
        (UploadFile & {
            url?: string;
            fileId?: number;
            status?: string;
            deleteState?: boolean;
        })[]
            >([])
    const typeParams = useRef('')
    // 评审类型
    const approvalType = [
        { id: 1, label: t('technicalPlan') },
        { id: 2, label: t('technicalDefineAndResearchTaskBook') },
        { id: 3, label: t('technicalAchievementDelivery') },
        { id: 4, label: t('buTMTApproveTech') },
    ]
    const technologicalLeadershipArr = useRef([
        {
            label: t('leadership'),
            id: 1,
        },
        // {
        //     label: t('homeleadership'),
        //     id: 4,
        // },
        {
            label: t('equalize'),
            id: 2,
        },
        {
            label: t('trail'),
            id: 3,
        },
    ])
    const technicalContributionArr = useRef([
        {
            label: t('innovationSellingPoint'),
            id: 1,
        },
        {
            label: t('keySellingPoint'),
            id: 2,
        },
        {
            label: t('secondarySellingPoints'),
            id: 3,
        },
        {
            label: t('infrastructure'),
            id: 4,
        },
    ])

    const layout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 10 },
    }
    const tailLayout = {
        wrapperCol: { offset: 6, span: 10 },
    }
    const handleUpload = async (files: UploadFile[]) => {
        const formData = new FormData()
        if (files.length > 10) {
            setUploading(false)
            setFileList([...fileList])
            dispatch(requestFail('Files Must less 10!' + '--' + Math.random()))
            uploadFileLs.current = []
            return
        }
        let flag = true
        try {
            files.forEach((file) => {
                if (file.size && file.size > 1024 * 1024 * 50) {
                    throw Error()
                }
                formData.append('multipartFile', file as RcFile)
            })
        } catch (e) {
            flag = false
            setUploading(false)
            setFileList([...fileList])
            dispatch(requestFail('File Size Must limt 50M!' + '--' + Math.random()))
        }
        const _fileList = _.cloneDeep(fileListRef.current)
        try {
            if (!flag) {
                uploadFileLs.current = []
                return
            }
            const res = await uploadFile(formData)

            // 检查组件是否还在挂载中
            if (!isMountedRef.current) return

            setFileIds([...fileIds, ...res.map((item) => item.id)])
            const resLen = res.length,
                fileListLen = fileListRef.current.length
            for (let i = fileListLen - 1; i > fileListLen - resLen - 1; i--) {
                const resFile = res.pop();
                (_fileList[
                    i
                ].url = `${UploadAPI}/onlinePreview?filePath=${resFile?.fullPath}`),
                (_fileList[i].fileId = resFile?.id)
                _fileList[i].status = 'done'
            }
            console.log('_fileList: ', _fileList)
            setFileList(_fileList)
            uploadFileLs.current = []
        } catch (error: any) {
            _fileList.forEach((item) => {
                const findIndex = files.findIndex((file) => file.uid === item.uid)
                if (findIndex !== -1) {
                    item.status = 'error'
                }
            })
            setFileList(_fileList)
            const str = getErrorStr(error)
            dispatch(requestFail(str + '--' + Math.random()))
        }
        setUploading(false)
    }

    const fn = debounce(() => {
        console.log('uploadFileLs.current: ', uploadFileLs.current)
        // 过滤出已经上传成功的
        const uploadList = uploadFileLs.current.filter((file) => {
            const findObj = fileList.find((item) => item.uid === file.uid)
            if (findObj) {
                return findObj.status !== 'done'
            }
            return true
        })
        handleUpload(uploadList)
    }, 1000)

    const props: UploadProps = {
        fileList,
        showUploadList: {
            showDownloadIcon: true,
            downloadIcon: (
                <Text className="txt_blue hand" title={t('downloadFile')}>
                    <DownloadOutlined style={{ fontSize: 16 }} />
                </Text>
            ),
            removeIcon: (
                <Text className="txt_red hand" title={t('delete')}>
                    <DeleteOutlined style={{ fontSize: 16 }} />
                </Text>
            ),
        },
        multiple: true,
        beforeUpload: (file) => {
            setUploading(true)
            console.log('beforeUpload', file)
            uploadFileLs.current.push(file)
            return false
        },
        onChange: (info) => {
            console.log('onChange: ', info)
            fileListRef.current = info.fileList
            const addList = info.fileList.filter(
                (file) => !('fileId' in file) && file.status !== 'done'
            )
            addList.forEach((item) => {
                item.status = 'uploading'
            })
            const fileArr = _.unionWith(fileList, addList, (a: any, b: any) => {
                return _.isEqual(a.uid, b.uid)
            })
            setFileList(fileArr)
            fn()
        },
        onDownload: async (
            file: UploadFile & {
                url?: string;
                fileId?: number;
                status?: string;
            }
        ) => {
            try {
                if (file.fileId) {
                    file.status = 'uploading'
                    const findIndex = fileList.findIndex(
                        (item) => item.fileId === file.fileId
                    )
                    fileList.splice(findIndex, 1, file)
                    setFileList([...fileList])
                    const res = await getFile(file.fileId)
                    downloadFile(res, file.name)
                    file.status = 'done'
                    fileList.splice(findIndex, 1, file)
                    setFileList([...fileList])
                }
            } catch (error: any) {
                const str = getErrorStr(error)
                dispatch(requestFail(str))
            }
        },
        onRemove: async (
            file: UploadFile & {
                url?: string;
                fileId?: number;
                status?: string;
            }
        ) => {
            const index = fileList.findIndex((item) => file.fileId === item.fileId)
            try {
                file.status = 'removed'
                const findIndex = fileList.findIndex(
                    (item) => item.fileId === file.fileId
                )
                fileList.splice(findIndex, 1, file)
                setFileList([...fileList])
                if (file.fileId) {
                    await delFile(file.fileId as number)
                }
                fileList.splice(index, 1)
                setFileList([...fileList])
                setFileIds(fileIds.filter((item) => item !== file.fileId))
                // 删除上传列表对应 uid 的文件
                const findIndex2 = uploadFileLs.current.findIndex(
                    (item) => item.uid === file.uid
                )
                uploadFileLs.current.splice(findIndex2, 1)
                if (file.fileId) {
                    return Promise.resolve()
                } else {
                    return Promise.reject('111')
                }
            } catch (error: any) {
                file.status = 'error'
                const str = getErrorStr(error)
                dispatch(requestFail(str))
                // 删除上传列表对应 uid 的文件
                const findIndex2 = uploadFileLs.current.findIndex(
                    (item) => item.uid === file.uid
                )
                uploadFileLs.current.splice(findIndex2, 1)
                return Promise.reject(error)
            }
        },
    }

    // 提案申请相关性反馈
    const onFinish = async (values: any) => {
        console.log(values, 'mmmmmmmmmmmmmmmmmmmmmmmmmmmm0000000000000')
        try {
            setLoading(true)
            if (leaders.length === 0) {
                const args = {
                    message: t('noLeader'),
                    description: '',
                    icon: <CloseCircleOutlined style={{ color: '#f61a1a' }} />,
                    duration: 3,
                }
                notification.open(args)
                return
            }
            const description = editorRef.current?.serialize({
                children: serialize(handleTrim(descriptionValue)),
            })
            const standardOutput = editor2Ref.current?.serialize({
                children: serialize(handleTrim(standardOutputValue)),
            })
            const formData = {
                ...values,
                parentId: values.parentId ? Number(values.parentId) : undefined,
                isCross: values.technologyCertification === 2 ? true : undefined,
                isDisruptive: values.technologyCertification === 1 ? true : undefined,
                fileIds: values.fileIds || [],
                reviewDateHours: values.reviewDateHours
                    ? [
                        values.reviewDateHours[0]?.format('HH:mm'),
                        values.reviewDateHours[1]?.format('HH:mm'),
                    ].join('~')
                    : '',
                description: JSON.stringify({
                    str: description,
                    obj: descriptionValue,
                }),

                reviewDate: values.reviewDate?.format('YYYY-MM-DD'),
                firstUseDate: values.firstUseDate?.format('YYYY-MM-DD'),
                // 如果是成果交付，且选择的提案类型为4时，需要增加一个字段 responsibles
                // responsibles: (selectProposal && selectProposal.responsible) ? [selectProposal.responsible] : values.responsibles,
                // 人员列表存的是字符串，页面展示是数组，此处需要转换一下格式
                techLeaders: values.techLeaders?.join(','),
                coreMembers: values.coreMembers?.join(','),
                generalMembers: values.generalMembers?.join(','),
            }
            if (reviewType !== 1) {
                formData.standardName = values.standardName
                formData.standardOutput = JSON.stringify({
                    str: standardOutput,
                    obj: standardOutputValue,
                })
            }
            if (reviewType === 2) {
                console.log(allSelectTechObj, 'allSelectTechObj')
                formData.techIds = allSelectTechObj.map(
                    (item: any) => item.techProject.id
                )
            } else if (reviewType === 3) {
                formData.standardNumber = values.standardNumber
                formData.standardLink = values.standardLink
                formData.relevants =
                    itmtRelevant?.map((item: any) => ({
                        ...item,
                        workGroupId:
                            item.workGroup !== null
                                ? item.workGroup.id || item.workGroup.workGroupId
                                : 9999,
                    })) || []
            }
            console.log('onFinish: ', values, 'formData: ', formData)
            // TODO:
            // const flag = true
            // if (flag) {
            //     return
            // }

            if (!formObj || !formObj.id) {
                await addOnlineReview(formData)
            } else {
                await editOnlineReview({
                    ...formObj,
                    ...formData,
                })
            }

            // 检查组件是否还在挂载中
            if (!isMountedRef.current) return

            const args = {
                message: t('save') + (i18n.language !== 'zh' ? ' ' : '') + t('success'),
                description: '',
                icon: <CheckCircleOutlined style={{ color: '#08993f' }} />,
                duration: 3,
            }
            localStorage.setItem('curTab', reviewType)
            notification.open(args)
            if (locationObj.key) {
                history.goBack()
            } else {
                history.replace('/techReviewProgress')
            }

        } catch (error: any) {
            // 检查组件是否还在挂载中
            if (!isMountedRef.current) return

            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
        finally {
            setLoading(false)
        }
    }
    const onFinishFailed = ({ errorFields }: { errorFields: any }) => {
        console.log('errorFields: ', errorFields)
        if (errorFields && errorFields.length > 0) {
            const firstErrorField = errorFields[0]
            const fieldName = firstErrorField.name[0]

            // 找到对应的Form.Item
            const formItemElement = document.querySelector(`[data-field="${fieldName}"]`)
            if (formItemElement) {
                formItemElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
            } else {
                // 如果找不到Form.Item,使用Form的scrollToField方法
                form.scrollToField(fieldName, {
                    behavior: 'smooth',
                    block: 'center'
                })
            }
        }
    }
    const onReset = () => {
        form.resetFields()
        setRelatedResponsiblePersons([])
        setDevSubject([])
        setDevCostAttr([])
    }



    const getBuListFn = async () => {
        try {
            if (!isMountedRef.current) return
            const resData = await getOrgRoleUsers({
                orgRole: 10,
            })

            dispatchR({ type: SetBuList, payload: resData })
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }

    const getWorkgroupItem = useCallback(
        (workGroupId: number) => {
            return workgroupList.find((item: IWorkgroup) => item.id === workGroupId)
        },
        [workgroupList]
    )

    const setStandardDesc = () => {
        const desc: any[] = [
            {
                type: 'paragraph',
                children: [
                    {
                        text: '目标：',
                        bold: true,
                    },
                ],
            },
            {
                type: 'paragraph',
                children: [
                    {
                        text: '',
                    },
                ],
            },
            {
                type: 'paragraph',
                children: [
                    {
                        text: '意义:',
                        bold: true,
                    },
                ],
            },
            {
                type: 'paragraph',
                children: [
                    {
                        text: '',
                    },
                ],
            },
            {
                type: 'paragraph',
                children: [
                    {
                        text: '价值及简要说明：',
                        bold: true,
                    },
                ],
            },
            {
                type: 'paragraph',
                children: [
                    {
                        text: '',
                    },
                ],
            },
        ]

        setStandardOutputValue(desc)
    }

    const setDefultDesc = (type: number) => {
        let desc: any[] = [
            {
                type: 'paragraph',
                children: [
                    {
                        text: '背景（选填）：',
                        bold: true,
                    },
                ],
            },
            {
                type: 'paragraph',
                children: [
                    {
                        text: '',
                    },
                ],
            },
            {
                type: 'paragraph',
                children: [
                    {
                        text: '需求（选填）：',
                        bold: true,
                    },
                ],
            },
            {
                type: 'paragraph',
                children: [
                    {
                        text: '',
                    },
                ],
            },
            {
                type: 'paragraph',
                children: [
                    {
                        text: '目标（选填）：',
                        bold: true,
                    },
                ],
            },
            {
                type: 'paragraph',
                children: [
                    {
                        text: '',
                    },
                ],
            },
        ]
        switch (type) {
            case 1:
                break
            case 2:
                break
            case 3:
                desc = [
                    {
                        type: 'paragraph',
                        children: [
                            {
                                text: '背景：',
                                bold: true,
                            },
                        ],
                    },
                    {
                        type: 'paragraph',
                        children: [
                            {
                                text: '',
                            },
                        ],
                    },
                    {
                        type: 'paragraph',
                        children: [
                            {
                                text: '功能描述：',
                                bold: true,
                            },
                        ],
                    },
                    {
                        type: 'paragraph',
                        children: [
                            {
                                text: '',
                            },
                        ],
                    },
                    {
                        type: 'paragraph',
                        children: [
                            {
                                text: '验收指标：',
                                bold: true,
                            },
                        ],
                    },
                    {
                        type: 'paragraph',
                        children: [
                            {
                                text: '',
                            },
                        ],
                    },
                ]
                break
            case 4:
                break
            default:
                desc = [
                    {
                        type: 'paragraph',
                        children: [{ text: '' }],
                    },
                ]
        }

        // 同时更新表单值和状态
        form.setFieldValue('description', desc)

        setEditorKey(getUuid(8))
        setEditor1Key(getUuid(8))
    }
    const onChangeIsCommunicate = (val: boolean) => {
        form.setFieldValue('isCommunicate', val)
        if (val) {
            const reviewTypeVal = form.getFieldValue('reviewType')
            console.log('reviewTypeVal: ', reviewTypeVal, typeof reviewTypeVal)
            setDefultDesc(reviewTypeVal)
            setStandardDesc()
        }
    }
    const onChangeReviewType = (val: number) => {
        console.log('onChangeReviewType: ', val)
        if (val === 4 && !stateR.buList) {
            getBuListFn()
        }
        if (isCommunicate) {
            setDefultDesc(val)
            setStandardDesc()
        }
        dispatchR({ type: SetReviewType, payload: val })
        dispatchR({
            type: SetSelectTechList,
            payload: [],
        })
        dispatchR({ type: SetProposal, payload: null })
        dispatchR({ type: SetReviewHistory, payload: null })
    }

    const buLeader = useMemo(() => {
        const userBuArr = userInfo?.bu?.split(',')
        const result: string[] = []
        userBuArr?.forEach((bu) => {
            const findObj = stateR.buList?.find((item: any) => item.bu.includes(bu))
            if (findObj) {
                result.push(findObj.nickName)
            }
        })
        return result
    }, [userInfo, stateR.buList])

    const techIds = useWatch('techIds', form)

    useEffect(() => {
        if (techIds && techIds.length > 0) {
            setSelectionKey(techIds)

        } else {
            setSelectionKey([])
        }
    }, [techIds])


    // 选择提案后，隐藏提案选择弹窗
    const onHideSelectProposalListPop = async (value: any) => {
        console.log('value: ', value)
        dispatchR({ type: SetProposal, payload: value })
        dispatchR({ type: SetSelectTechList, payload: value.techProjects.map((item: any) => ({ techProject: item })) })
        // 检查 value 是否存在，避免访问 undefined 的属性
        if (value) {
            form?.setFieldValue('projectId', value.id)
            form?.setFieldValue('proposalName', value.proposalName)
            form?.setFieldValue('techIds', value.techProjects.map((item: any) => item.id))
        }
    }


    // 选择课题后，隐藏课题选择弹窗
    const onHideSelectTechListPop = async (values: any) => {
        const formObjTemp = formObj
            ? ({ ...formObj } as IAddOnlineReviewData)
            : null
        // const formRefTemp = formRef.current ? { ...formRef.current } : undefined
        dispatchR({ type: HideSelectTechListPop })
        if (!values) return
        // if (
        //     reviewType === 3 &&
        //     Object.prototype.toString.call(values) === '[object Array]'
        // ) { 
        //     console.log(allSelectTechObj,'allSelectTechObj')
        //     // 如果 系统中已有"技术定义与研究任务书评审"记录, 系统根据"技术编号"关联原"技术定义与研究任务书评审"的领域相关性及评委名单
        //     // 显示出记录列表，并保存到 relevants 字段
        //     const res = await getReviewHistory({
        //         reviewType: 2,
        //         techId: allSelectTechObj.map((item: any) => item.techProject.id).join(','),
        //     })
        //     console.log(res, 'kkkkkkkkkkkkkkkk')
        //     dispatchR({ type: SetReviewHistory, payload: res.length ? res : null })
        // }
        if (Object.prototype.toString.call(values) !== '[object Array]') {
            values = [values]
        }
        const newAdds = values.map((item: any) => ({ techProject: item }))
        const payload = _.unionWith(allSelectTechObj, newAdds, (a: any, b: any) => {
            return _.isEqual(a.techProject.id, b.techProject.id)
        })
        // let payload: any
        // if (reviewType === 2) {

        // } else {
        //     payload = values.map((item: any) => ({
        //         techProject: item,
        //     }))
        // }
        dispatchR({
            type: SetSelectTechList,
            payload,
        })
        const techIds = payload.map((item: any) => item.techProject.id)
        if (formObjTemp) {
            setFormObj({
                ...formObjTemp,
                techIds,
            })
        }
        form?.setFieldValue('techIds', techIds)
        form?.setFieldValue('approvalRecord', null)
        dispatchR({ type: SetITMTRelevant, payload: null })
        setHasOffline(false)
    }
    const onDelSelectTech = (val: any) => {
        const findIndex = allSelectTechObj.findIndex(
            (item: any) => item.techProject.id === val.techProject.id
        )
        allSelectTechObj.splice(findIndex, 1)
        const payload = [...allSelectTechObj]
        if (findIndex !== -1) {
            // const techIds = payload.map((item: any) => item.techProject.id)
            // if (formObj) {
            //     setFormObj({
            //         ...formObj,
            //         techIds,
            //     })
            // }
            // console.log(selectRecord,'mmmmmmmmmmmmmmmmmmmmmmmmmmmm12000000')
            // form.setFieldValue('techIds', techIds)
            setSelectionKey(
                selectionKey.filter((item) => item !== val.techProject.id)
            )
            setSelectRecord(
                selectRecord.filter((item: any) => item.id !== val.techProject.id)
            )
            // const pay = reviewHistory.filter(
            //     (i: any) =>
            //         !i.techProjects.some((j: any) => j.id === val.techProject.id)
            // )

            // dispatchR({ type: SetReviewHistory, payload: pay.length ? pay : null })
            dispatchR({ type: SetSelectTechList, payload })
            if (payload.length < 1) {
                setSelectionKey([])
                setSelectRecord([])
                dispatchR({ type: SetReviewHistory, payload: null })
                dispatchR({ type: SetITMTRelevant, payload: null })
            }
        }
    }

    // 选择评审记录后，获取记录对应的 ITMT 反馈详情
    const onClickReviewHistory = async (e: RadioChangeEvent) => {
        const itmtRelevantRes = await relevantGetById(Number(e.target.value))
        itmtRelevantRes.forEach((item) => {
            item.key = item.id
        })
        dispatchR({ type: SetITMTRelevant, payload: itmtRelevantRes })
        form?.setFieldValue(
            'relevants',
            itmtRelevantRes.map((item) => ({
                auditOrNot: item.auditOrNot,
                description: item.description,
                isRelevant: item.isRelevant,
                tmtInfos: item.tmtInfos,
                workGroupId: item.workGroup !== null ? item.workGroup.id : 9999,
            }))
        )
    }

    const dutyBuss = Form.useWatch('dutyBuss', form)
    const costBuss = Form.useWatch('costBuss', form)

    // 选择BU/CT清单后
    const selectBuCallback = (res: IBu[]) => {
        console.log(res, 'selectBuCallback')
        const ids = res.map((item) => item.id)
        if (curSelectType === 'devSubject') {
            form.setFieldValue('dutyBuss', ids)
            form.validateFields(['dutyBuss'])
            setDevSubject(res)
        } else if (curSelectType === 'devCostAttr') {
            form.setFieldValue('costBuss', ids)
            form.validateFields(['costBuss'])
            setDevCostAttr(res)
        }
    }
    // 选择业务相关责任人
    const selectPersonCallback = (res: IPerson[]) => {
        setRelatedResponsiblePersons(res)
        formRef.current?.setFieldValue(
            'responsibles',
            res.map((item) => item.login)
        )
        formRef.current?.validateFields(['responsibles'])
    }

    // 第三类选择课题后，选择线下评审
    const onChangeHasOffline = (val: boolean) => {
        setHasOffline(val)
    }
    const onAddOffline = () => {
        if (hasOffline) {
            setShowSelectUser(true)
        }
    }
    // 第三类选择课题后，选择评审评委
    const selectUserCallback = ({
        users: val,
        isItmtRelevant,
    }: {
        users: any;
        isItmtRelevant?: boolean;
    }) => {
        const formRefTemp = formRef.current ? { ...formRef.current } : undefined
        if (!isItmtRelevant) {
            dispatchR({ type: SetTMTJudge, payload: val })
        } else {
            val.forEach((item: any) => {
                item.key = getUuid(8)
            })
            dispatchR({ type: SetITMTRelevant, payload: val })
            formRefTemp?.setFieldValue('relevants', val)
        }
    }
    // 标准输出仅限关键和核心输出
    const [isCoreOrKey, setCoreOrKey] = useState<boolean>(false)

    // 选择技术领先性或技术贡献性后，计算是否核心技术
    const onChangeSelect = () => {
        const technologyLeadership = formRef.current?.getFieldValue(
            'technologyLeadership'
        )
        const technologyContribution = formRef.current?.getFieldValue(
            'technologyContribution'
        )

        // 只有当两个值都选择后才进行计算
        if (technologyLeadership && technologyContribution) {
            // 获取技术先进程度值 α
            // 领先 = 1.5,国内领先 = 1.2, 先进 = 1.0, 追赶 = 0.7
            const alpha =
                technologyLeadership === 1
                    ? 1.5
                    : technologyLeadership === 4
                        ? 1.2 // 国内领先
                        : technologyLeadership === 2
                            ? 1.0 // 先进
                            : 0.7 // 追赶

            // 获取技术贡献度值 β
            // 创新卖点 = 0.3, 主要卖点 = 0.2, 次要卖点 = 0.1, 基础设施 = 0.05
            const beta =
                technologyContribution === 1
                    ? 0.3 // 创新卖点
                    : technologyContribution === 2
                        ? 0.2 // 主要卖点
                        : technologyContribution === 3
                            ? 0.1 // 次要卖点
                            : 0.05 // 基础设施

            // 根据坐标位置判断技术类型
            if (alpha >= 1.0 && beta >= 0.2) {
                formRef.current?.setFieldValue('coreTechnology', 0) // 核心技术
                setCoreOrKey(true)
            } else if (beta >= 0.2) {
                formRef.current?.setFieldValue('coreTechnology', 1) // 关键技术
                setCoreOrKey(true)
            } else if (alpha >= 1.0) {
                formRef.current?.setFieldValue('coreTechnology', 3) // 储备技术
                setCoreOrKey(false)
            } else {
                formRef.current?.setFieldValue('coreTechnology', 2) // 基础技术
                setCoreOrKey(false)
            }
        } else {
            // 如果有值未选择，重置状态
            formRef.current?.setFieldValue('coreTechnology', -1)
            setCoreOrKey(false)
        }
    }

    // 选择技术领头人、核心成员、一般成员后
    const onChangeLeader = (val: any, field: string) => {
        console.log('val: ', val, field)
        // formRef.current?.setFieldValue(field, val)
    }


    // 封装拼接字符串的函数
    const joinTranslatedStrings = (...translations: string[]) => {
        return translations.join(i18n.language !== 'zh' ? ' ' : '')
    }

    // 根据id获取申请详细信息 编辑初始化
    const getDetail = async (id: string, isSecond: boolean) => {
        try {
            const res = await getOnlineReviewById(+id)

            // 检查组件是否还在挂载中
            if (!isMountedRef.current) return

            console.log(res, 'mmmmmmmmmmmmmm123mmmmmmmmmmmmmmmmmm')
            if (res) {
                const fileIds = res.files.map((item) => item.id)
                setloaded(true)
                const reviewDateHours = res.reviewDateHours?.includes('~')
                    ? res.reviewDateHours
                        .split('~')
                        .map((item) => moment(moment().format('YYYY-MM-DD') + ' ' + item))
                    : undefined

                // console.log('test2', {
                //     parentId: isSecond ? id : undefined,
                //     id: !isSecond ? res.id : undefined,
                //     version: res.version,
                //     fileIds,
                //     workGroupId: res.workGroup.id,
                //     workGroupName: res.workGroup.workGroupName,
                //     crossBreedWorkGroupId: res.crossBreedWorkGroup?.id ?? null,
                //     crossBreedWorkGroupName: res.crossBreedWorkGroup?.workGroupName ?? '',
                //     roadMap: res.roadMap,
                //     proposalName: res.proposalName,
                //     subsidiary: res.subsidiary,
                //     dueDate: moment(res.dueDate).format('YYYY-MM-DD'),
                //     tmtReviewDueDate: moment(res.tmtReviewDueDate).format('YYYY-MM-DD'),
                //     reviewDate: moment(res.reviewDate),
                //     reviewDateHours,
                //     dutyBuss: res?.dutyBuss?.map((item) => Number(item.id)) || [],
                //     costBuss: res?.costBuss?.map((item) => Number(item.id)) || [],
                //     // isDisruptive: res.isDisruptive,
                //     // isCross: res.isCross,
                //     technologyCertification: res.isDisruptive ? 1 : res.isCross ? 2 : 0,
                //     reviewType: res.reviewType,
                //     techLevel: res.techLevel,
                //     description: res.description,
                //     isCommunicate: true,
                //     isPlReview: res.isPlReview,
                //     techSource: isNaN(Number(res.techSource))
                //         ? res.techSource
                //         : [
                //             t('independentIP'),
                //             t('outsourcedTechnology'),
                //             t('coDevelopedTechnology'),
                //         ][Number(res.techSource) - 1],
                //     // 人员列表存的是字符串，页面展示是数组，此处需要转换一下格式
                //     techLeaders: res.techLeaders?.split(',') ?? [],
                //     coreMembers: res.coreMembers?.split(',') ?? [],
                //     generalMembers: res.generalMembers?.split(',') ?? [],
                //     technologyLeadership: res.technologyLeadership,
                //     technologyContribution: res.technologyContribution,
                //     coreTechnology: res.coreTechnology,
                //     productFunction: res.productFunction,
                //     techScope: res.techScope,
                //     techPerformance: res.techPerformance,
                //     firstUseDate: moment(res.firstUseDate),
                //     // 添加标准输出
                //     standardName: res.standardName,
                //     standardOutput: res.standardOutput,
                //     standardNumber: res.standardNumber,
                //     standardLink: res.standardLink,
                // })
                setFormObj({
                    parentId: isSecond ? id : undefined,
                    id: !isSecond ? res.id : undefined,
                    version: res.version,
                    fileIds,
                    workGroupId: res.workGroup.id,
                    workGroupName: res.workGroup.workGroupName,
                    crossBreedWorkGroupId: res.crossBreedWorkGroup?.id ?? null,
                    crossBreedWorkGroupName: res.crossBreedWorkGroup?.workGroupName ?? '',
                    roadMap: res.roadMap,
                    proposalName: res.proposalName,
                    subsidiary: res.subsidiary,
                    dueDate: moment(res.dueDate).format('YYYY-MM-DD'),
                    tmtReviewDueDate: moment(res.tmtReviewDueDate).format('YYYY-MM-DD'),
                    reviewDate: moment(res.reviewDate),
                    reviewDateHours,
                    dutyBuss: res?.dutyBuss?.map((item) => Number(item.id)) || [],
                    costBuss: res?.costBuss?.map((item) => Number(item.id)) || [],
                    // isDisruptive: res.isDisruptive,
                    // isCross: res.isCross,
                    technologyCertification: res.isDisruptive ? 1 : res.isCross ? 2 : 0,
                    reviewType: res.reviewType,
                    techLevel: res.techLevel,
                    description: res.description,
                    isCommunicate: true,
                    isPlReview: res.isPlReview,
                    techSource: isNaN(Number(res.techSource))
                        ? res.techSource
                        : [
                            t('independentIP'),
                            t('outsourcedTechnology'),
                            t('coDevelopedTechnology'),
                        ][Number(res.techSource) - 1],
                    // 人员列表存的是字符串，页面展示是数组，此处需要转换一下格式
                    techLeaders: res.techLeaders?.split(',') ?? [],
                    coreMembers: res.coreMembers?.split(',') ?? [],
                    generalMembers: res.generalMembers?.split(',') ?? [],
                    technologyLeadership: res.technologyLeadership,
                    technologyContribution: res.technologyContribution,
                    coreTechnology: res.coreTechnology,
                    productFunction: res.productFunction,
                    techScope: res.techScope,
                    techPerformance: res.techPerformance,
                    firstUseDate: moment(res.firstUseDate),
                    // 添加标准输出
                    standardName: res.standardName,
                    standardOutput: res.standardOutput,
                    standardNumber: res.standardNumber,
                    standardLink: res.standardLink,
                })
                setDevSubject(res?.dutyBuss || [])
                setDevCostAttr(res?.costBuss || [])
                if (res?.responsible) {
                    const r = await getOrgRoleUsers({
                        orgRole: RoleCont.PLTMTLeader,
                    })
                    const userData = r.filter((item: any) =>
                        item.login.includes(res?.responsible?.split(','))
                    ) as any
                    setRelatedResponsiblePersons(userData)
                }
                form.setFieldValue('techCertification', res.isCross ? 2 : res.isDisruptive ? 1 : 0)
                dispatchR({ type: SetReviewType, payload: res.reviewType })
                dispatchR({
                    type: SetSelectTechList,
                    payload: res.parent
                        ? res.parent.techProjects?.map((item) => ({ techProject: item }))
                        : res.techProjects?.map((item) => ({ techProject: item })),
                })
                setFileIds(fileIds)
                setFileList(
                    res.files.map((item) => ({
                        uid: '',
                        name: item?.fileName,
                        url: `${UploadAPI}/onlinePreview?filePath=${item?.filePath}`,
                        fileId: item?.id,
                        status: 'done',
                    }))
                )
                changeWorkgroup(res.workGroup.id)
                if (res.description) {
                    form.setFieldValue('description', JSON.parse(res.description).obj)
                    // 富文本编辑器key
                    setEditorKey(getUuid(8))
                }
                if (res.standardOutput) {
                    setStandardOutputValue(JSON.parse(res.standardOutput).obj) // 富文本编辑器key
                    setEditor1Key(getUuid(8))
                    setCoreOrKey(true)
                }
                // 如果有 itmt 反馈后，则不能再修改除附件之外的
                const itmtRelevantRes = await relevantGetById(+id)
                // dispatchR({ type: SetITMTRelevant, payload: itmtRelevantRes })
                if (itmtRelevantRes && itmtRelevantRes.length > 0) {
                    setIsRelevantRes(true)
                }
            }
        } catch (error: any) {
            const str = getErrorStr(error)
            dispatch(requestFail(str))
        }
    }
    // 获取多少日个工作日后的日期
    const getWorkDateFun = async () => {
        const res = await getWorkDateDiff({
            startDay: moment().format('YYYYMMDD'),
            diffDay: 2,
        })

        // 检查组件是否还在挂载中
        if (!isMountedRef.current) return

        console.log('getWorkDateDiff: ', res)
        setSelectStartDate(moment(res))
    }
    // 获取 workgroup Leader
    const changeWorkgroup = async (val: number) => {
        const res = await getWorkgroupLeader({
            workGroupId: val,
            orgRole: RoleCont.ITMTLEADER,
        })

        // 检查组件是否还在挂载中
        if (!isMountedRef.current) return

        setSelWorkgroup(getWorkgroupItem(val) ?? null)
        setLeaders(res)
    }
    const changeCrossWorkgroup = async (val: number) => {
        const workgroupItem = getWorkgroupItem(val)
        console.log('val: ', val, workgroupItem)
    }
    const clearWorkgroup = () => {
        setSelWorkgroup(null)
        setLeaders([])
    }


    const [routes, setRoutes] = useState([
        {
            path: '/indexPage',
            breadcrumbName: t('indexPage'),
        },
        {
            path: '/techReviewProgress',
            breadcrumbName: t('technicalReviewProcess'),
        },
        {
            path: '/techReviewAdd',
            breadcrumbName:
                t('add') + (i18n.language !== 'zh' ? ' ' : '') + t('technicalReview'),
        },
    ])
    useEffect(() => {
        console.log('locationObj: ', locationObj)
        const curRoute = {
            path: '/techReviewAdd',
            breadcrumbName: t('technicalReview'),
        }
        if (locationObj.pathname.includes('Add')) {
            curRoute.breadcrumbName =
                t('add') +
                (i18n.language !== 'zh' ? ' ' : '') +
                curRoute.breadcrumbName
        } else if (locationObj.pathname.includes('Edit')) {
            curRoute.breadcrumbName = joinTranslatedStrings(t('edit'), curRoute.breadcrumbName)
            setIsEdit(true)
        }
        const routeParams = new URLSearchParams(location.search)
        const reviewId = routeParams.get('id')
        const type = routeParams.get('type')
        const more = routeParams.get('more')
        if (type) {
            localStorage.setItem('curTab', type)
            typeParams.current = type
        }
        setRoutes([
            routes[0],
            {
                path: '/techReviewProgress',
                breadcrumbName: approvalType[(Number(type) || 1) - 1].label,
            },
            curRoute,
        ])
        if (reviewId) {
            getDetail(reviewId, more === 'true')
        } else {
            // 新建场景，设置默认值
            setloaded(true)

            // 如果是新建且有reviewType，设置默认描述
            if (type && isCommunicate) {
                setDefultDesc(Number(type))
            }
        }
        setEditorKey(getUuid(8))
        setEditor1Key(getUuid(8))
        if (workgroupList.length === 0) {
            dispatch(getWorkgroup())
        }
        getWorkDateFun()

        return () => {
            isMountedRef.current = false
        }
    }, [])

    // 添加一个单独的useEffect来处理新建时的默认描述设置
    useEffect(() => {
        const routeParams = new URLSearchParams(location.search)
        const reviewId = routeParams.get('id')
        const type = routeParams.get('type')

        // 只在新建场景（没有reviewId）且isCommunicate为true时设置默认描述
        if (!reviewId && type && isCommunicate && loaded) {
            setDefultDesc(Number(type))
        }
    }, [isCommunicate, loaded])

    useEffect(() => {
        if (formObj) {
            console.log('formObj: ', formObj)
            form.setFieldsValue({
                ...formObj,
                dueDate: moment(formObj.dueDate),
            })
        }
    }, [formObj])

    useEffect(() => {
        if (loaded && !formObj) {
            if (typeParams.current) {
                form.setFieldValue('reviewType', Number(typeParams.current))
                dispatchR({ type: SetReviewType, payload: Number(typeParams.current) })
                getBuListFn()
            }
            // 设置 description 字段的默认值，防止 Slate 编辑器报错
            if (!form.getFieldValue('description')) {
                form.setFieldValue('description', [
                    {
                        type: 'paragraph',
                        children: [{ text: '' }],
                    },
                ])
            }
        }
    }, [loaded])

    const validateAuthByKey = (key: string) => validateAuth(authInfo, key)

    const isCTStaff = useMemo(() => {
        return userInfo?.bu?.includes('CT')
    }, [userInfo])

    useEffect(() => {
        form.setFieldValue('fileIds', fileIds)
        form.validateFields(['fileIds'])
    }, [fileIds])



    return (
        <Space direction="vertical" size={10} style={{ width: '100%' }}>
            <Nav dispatch={dispatch} />
            <PageBreadcrumb
                routerParam={routes}
                history={history}
                dispatch={dispatch}
            />
            {loaded ? (
                <Form
                    form={form}
                    {...layout}
                    ref={formRef}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    className="edit_table"
                    disabled={loading}
                >
                    <Form.Item name="version" hidden>
                        <Input />
                    </Form.Item>
                    <Form.Item name="id" hidden>
                        <Input />
                    </Form.Item>
                    <Form.Item name="isCommunicate" hidden>
                        <Input />
                    </Form.Item>
                    <Form.Item name="parentId" hidden>
                        <Input />
                    </Form.Item>
                    <Form.Item name="techIds" hidden>
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="reviewType"
                        label={
                            <span className="label">
                                {t('proposalStage')}
                                <Popover
                                    title={null}
                                    trigger="hover"
                                    placement="bottomLeft"
                                    content={
                                        <span>
                                            {t('approvalTypeTips1')}
                                            <br />
                                            {t('approvalTypeTips2')}
                                            <br />
                                            {t('approvalTypeTips3')}
                                            <br />
                                            {t('approvalTypeTips4')}
                                        </span>
                                    }
                                >
                                    <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                                </Popover>
                            </span>
                        }
                        rules={[{ required: true, message: t('approval Type Required') }]}
                    >
                        {!isEdit ? (
                            <Select
                                allowClear
                                placeholder={
                                    joinTranslatedStrings(t('Please Select'), t('approval'), t('type'))
                                }

                                onChange={onChangeReviewType}
                            >
                                {approvalType.map((item) => {
                                    return (
                                        <Option disabled={isCTStaff && item.id === 4} key={item.id} value={item.id}>
                                            {item.label}
                                        </Option>
                                    )
                                })}
                            </Select>
                        ) : (
                            approvalType.find((item) => item.id === formObj?.reviewType)
                                ?.label || ''
                        )}
                    </Form.Item>
                    <Form.Item
                        name="workGroupId"
                        label={<span className="label">{t('Work Group')}</span>}
                        rules={[{ required: true, message: t('Work Group Required') }]}
                    >
                        {(validateAuthByKey('techReviewEdit') || !isEdit) ?
                            <Select
                                allowClear
                                placeholder={t('Work Group Placeholder')}
                                onChange={changeWorkgroup}
                                onClear={clearWorkgroup}
                            >
                                {workgroupList.map((item) => {
                                    return (
                                        <Option key={item.id} value={item.id}>
                                            {item.groupName}
                                        </Option>
                                    )
                                })}
                            </Select> :
                            (formObj?.workGroupName || '')
                        }
                    </Form.Item>
                    {leaders.length > 0 && (
                        <Form.Item label={<span className="label">Leader</span>}>
                            {leaders.map((item: any) => (
                                <span style={{ display: 'block' }} key={item.id}>
                                    {item.nickName}
                                </span>
                            ))}
                        </Form.Item>
                    )}

                    {/* 选择提案 */}
                    {reviewType === 3 && !formObj?.id && (
                        <>
                            <Form.Item
                                name="projectId"
                                label={<span className="label">{t('selectProposal')}</span>}
                                rules={[
                                    {
                                        required: true,
                                        validator: async (_rule, value) => {
                                            const helpStr =
                                                t('Please Select') +
                                                (i18n.language !== 'zh' ? ' ' : '') +
                                                t('viewInfo')
                                            if (value) {
                                                if (value.length === 0) {
                                                    return Promise.reject(new Error(helpStr))
                                                } else {
                                                    return Promise.resolve()
                                                }
                                            } else {
                                                return Promise.reject(new Error(helpStr))
                                            }
                                        },
                                    },
                                ]}
                            >
                                <Button
                                    type="text"
                                    style={{ cursor: 'pointer', color: '#036fc0' }}
                                    icon={<PlusCircleOutlined style={{ fontSize: 20 }} />}
                                    onClick={() => {
                                        dispatchR({ type: ShowSelectProposalPop })
                                    }}
                                ></Button>
                                {selectProposal && <p>{selectProposal.proposalName}</p>}
                            </Form.Item>
                        </>
                    )}
                    {(reviewType === 4 ||
                        (reviewType === 3 && selectProposal?.reviewType === 4)) && (
                        <>
                            <Form.Item
                                name="responsibles"
                                label={
                                    <span className="label">
                                        {t('businessRelatedResponsiblePersons')}
                                    </span>
                                }
                                rules={[
                                    {
                                        required: true,
                                        validator: async () => {
                                            if (
                                                !relatedResponsiblePersons ||
                                                    relatedResponsiblePersons.length === 0
                                            ) {
                                                const helpStr =
                                                        t('Please Select') +
                                                        (i18n.language !== 'zh' ? ' ' : '') +
                                                        t('businessRelatedResponsiblePersons')
                                                return Promise.reject(new Error(helpStr))
                                            } else {
                                                return Promise.resolve()
                                            }
                                        },
                                    },
                                ]}
                            >
                                <Input hidden />
                                {relatedResponsiblePersons.length > 0 && (
                                    <List
                                        style={{ marginBottom: 10, background: '#fff' }}
                                        bordered
                                        loading={{
                                            indicator: <></>,
                                            spinning: loading
                                        }}
                                        dataSource={relatedResponsiblePersons}
                                        renderItem={(item, index) => (
                                            <List.Item
                                                key={item.id}
                                                actions={
                                                    !isRelevantRes
                                                        ? [
                                                            <Text
                                                                className="txt_red hand"
                                                                title={t('delete')}
                                                                key={'relatedResponsiblePersons_' + item.id}
                                                                onClick={() => {
                                                                    relatedResponsiblePersons.splice(index, 1)
                                                                    setRelatedResponsiblePersons([
                                                                        ...relatedResponsiblePersons
                                                                    ])
                                                                    form.validateFields(['responsibles'])
                                                                }}
                                                            >
                                                                <DeleteOutlined style={{ fontSize: 16 }} />
                                                            </Text>,
                                                        ]
                                                        : []
                                                }
                                            >
                                                {item.nickName}
                                            </List.Item>
                                        )}
                                    />
                                )}
                                {!isRelevantRes && (
                                    <Button
                                        onClick={() => {
                                            setShowSelectPerson(true)
                                        }}
                                    >
                                        {t('Please Select') +
                                                (i18n.language !== 'zh' ? ' ' : '') +
                                                t('businessRelatedResponsiblePersons')}
                                    </Button>
                                )}
                            </Form.Item>
                            <Form.Item label={<span className="label">Bu Leader</span>}>
                                {buLeader}
                            </Form.Item>
                        </>
                    )}
                    {!isEdit && (
                        <Form.Item
                            name="isCommunicate"
                            key="isCommunicate"
                            valuePropName="checked"
                            label={
                                <span className="label">
                                    {t('isCommunicate')}
                                    <Popover
                                        title={null}
                                        trigger="hover"
                                        placement="bottomLeft"
                                        content={
                                            <span>
                                                {reviewType !== 4
                                                    ? t('isCommunicateTips')
                                                    : t('isCommunicateTips2')}
                                            </span>
                                        }
                                    >
                                        <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                                    </Popover>
                                </span>
                            }
                        >
                            <Switch
                                onChange={onChangeIsCommunicate}
                                disabled={!reviewType || !selWorkgroup}
                            />
                        </Form.Item>
                    )}
                    {isCommunicate && (
                        <>
                            {/* 技术成果交付提案名称 */}
                            <Form.Item
                                name="proposalName"
                                label={
                                    <span className="label">
                                        {approvalType[(reviewType || 1) - 1].label +
                                            (i18n.language !== 'zh' ? ' ' : '') +
                                            t('proposalName')}
                                    </span>
                                }
                                rules={[
                                    { required: true, message: t('proposalName Required') },
                                ]}
                            >
                                {!isEdit ? (
                                    <NoSpaceInput
                                        allowClear
                                        placeholder={
                                            t('Please Input') +
                                            (i18n.language !== 'zh' ? ' ' : '') +
                                            t('proposalName')
                                        }
                                    />
                                ) : (
                                    formObj?.proposalName
                                )}
                            </Form.Item>
                            {/* 如果是成果交付，则选择课题 (先选了提案以后才显示) */}
                            {((reviewType === 3 &&
                                selectProposal &&
                                selectProposal.reviewType === 2) ||
                                reviewType === 2) && (
                                <>
                                    {!isRelevantRes && (
                                        <Form.Item
                                            name="techIds"
                                            label={
                                                <span className="label">
                                                    {t('selectTech')}
                                                    <Popover
                                                        title={null}
                                                        trigger="hover"
                                                        placement="bottomLeft"
                                                        content={<span>{t('selectTopicTips')}</span>}
                                                    >
                                                        <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                                                    </Popover>
                                                </span>
                                            }
                                            rules={[
                                                {
                                                    required: true,
                                                    validator: async (_rule, value) => {
                                                        const helpStr = t('Tech Required')
                                                        if (value) {
                                                            if (value.length === 0) {
                                                                return Promise.reject(new Error(helpStr))
                                                            } else {
                                                                return Promise.resolve()
                                                            }
                                                        } else {
                                                            return Promise.reject(new Error(helpStr))
                                                        }
                                                    },
                                                },
                                            ]}
                                        >
                                            <Button
                                                type="text"
                                                style={{ cursor: 'pointer', color: '#036fc0' }}
                                                icon={<PlusCircleOutlined style={{ fontSize: 20 }} />}
                                                onClick={() => {
                                                    dispatchR({ type: ShowSelectTechListPop })
                                                }}
                                            ></Button>
                                        </Form.Item>
                                    )}
                                    {/* 回显课题列表 */}
                                    {(reviewType !== 3 ||
                                            (reviewType === 3 && selectProposal.reviewType !== 4) ||
                                            // 或编辑时 isPlReview 为 true
                                            formObj?.isPlReview) &&
                                            allSelectTechObj.map((techObj: any) => (
                                                <Space
                                                    direction="vertical"
                                                    size={0}
                                                    key={techObj.techProject.id}
                                                    className="form_item_mb"
                                                    style={{ width: '100%' }}
                                                >
                                                    {/* 技术点信息 */}
                                                    <Form.Item
                                                        label={
                                                            <span className="label">
                                                                {t('tech') +
                                                                    (i18n.language !== 'zh' ? ' ' : '') +
                                                                    t('name')}
                                                            </span>
                                                        }
                                                    >
                                                        <div style={{ display: 'flex' }}>
                                                            <div
                                                                className="desc"
                                                                dangerouslySetInnerHTML={{
                                                                    __html:
                                                                        techObj &&
                                                                            techObj?.techProject.techName &&
                                                                            techObj.techProject.techName.includes(
                                                                                'str'
                                                                            ) &&
                                                                            techObj.techProject.techName.includes('obj')
                                                                            ? JSON.parse(techObj.techProject.techName)
                                                                                .str
                                                                            : techObj.techProject.techName,
                                                                }}
                                                            ></div>
                                                            {/* 编辑时不能删除 */}
                                                            {!isEdit && (
                                                                <Button
                                                                    type="text"
                                                                    style={{ color: '#f00' }}
                                                                    icon={
                                                                        <CloseCircleOutlined
                                                                            style={{ fontSize: 20 }}
                                                                        />
                                                                    }
                                                                    onClick={() => onDelSelectTech(techObj)}
                                                                ></Button>
                                                            )}
                                                        </div>
                                                    </Form.Item>
                                                    <Form.Item
                                                        label={<span className="label">{t('PTN')}</span>}
                                                    >
                                                        {techObj && (
                                                            <>
                                                                <Text>{techObj.techProject.techPtn}</Text>
                                                            </>
                                                        )}
                                                    </Form.Item>
                                                    <Form.Item
                                                        label={
                                                            <span className="label">{t('techLevel')}</span>
                                                        }
                                                    >
                                                        <span>
                                                            {
                                                                [t('core'), t('key'), t('general'), t('normal')][
                                                                    ((techObj?.techProject.techLevel as number) ||
                                                                    1) - 1
                                                                ]
                                                            }
                                                        </span>
                                                    </Form.Item>
                                                    <Form.Item
                                                        label={
                                                            <span className="label">{t('subsidiary')}</span>
                                                        }
                                                    >
                                                        {techObj && (
                                                            <>
                                                                <Text>{techObj.techProject.subsidiary}</Text>
                                                            </>
                                                        )}
                                                    </Form.Item>
                                                    <Form.Item
                                                        label={
                                                            <span className="label">{t('description')}</span>
                                                        }
                                                    >
                                                        <div
                                                            className="desc"
                                                            dangerouslySetInnerHTML={{
                                                                __html:
                                                                    techObj &&
                                                                        techObj?.techProject.description &&
                                                                        techObj.techProject.description.includes(
                                                                            'str'
                                                                        ) &&
                                                                        techObj.techProject.description.includes('obj')
                                                                        ? JSON.parse(techObj.techProject.description)
                                                                            .str
                                                                        : techObj.techProject.description,
                                                            }}
                                                        ></div>
                                                    </Form.Item>
                                                </Space>
                                            ))}
                                </>
                            )}
                            {/* 第三类，如果没有评审记录，则显示 "是否有线下" */}
                            {reviewType === 3 && (
                                <>
                                    {/* 选择课题后，获取历史评审记录，供用户选择 */}
                                    {(
                                        <>
                                            <Form.Item name="relevants" hidden>
                                                <Input />
                                            </Form.Item>
                                            <Form.Item
                                                name="approvalRecord"
                                                label={
                                                    <span className="label">
                                                        {t('approval') +
                                                            (i18n.language !== 'zh' ? ' ' : '') +
                                                            t('record')}
                                                    </span>
                                                }
                                                rules={[
                                                    {
                                                        required: true,
                                                        message:
                                                            t('Please Select') +
                                                            (i18n.language !== 'zh' ? ' ' : '') +
                                                            t('approval') +
                                                            (i18n.language !== 'zh' ? ' ' : '') +
                                                            t('record'),
                                                    },
                                                ]}
                                            >
                                                <Radio.Group onChange={onClickReviewHistory}>
                                                    {/* {reviewHistory.map((item: any) => (
                                                        <Space direction="vertical" key={item.id}>
                                                           
                                                        </Space>
                                                    ))} */}
                                                    <Radio value={selectProposal.id}>{selectProposal.proposalName}</Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        </>
                                    )}
                                    {/* 用户选择评审记录后，再通过所选 id 获取 ITMT 申请反馈信息 */}
                                    {itmtRelevant && (
                                        <Form.Item {...tailLayout}>
                                            <FeedbackTable list={itmtRelevant} />
                                        </Form.Item>
                                    )}
                                    {/* 没有评审记录时，选择线下评委 */}
                                    {(!reviewHistory || reviewHistory.length < 1) &&
                                        !isRelevantRes &&
                                        allSelectTechObj.length > 0 && (
                                        <Form.Item
                                            label={<span className="label">{t('hasOffline')}</span>}
                                        >
                                            <Space>
                                                {/* 是否有线下评审 */}
                                                <Switch onChange={onChangeHasOffline} />
                                                {hasOffline && (
                                                    <Button
                                                        type="text"
                                                        style={{ color: '#036fc0' }}
                                                        icon={
                                                            <PlusCircleOutlined style={{ fontSize: 20 }} />
                                                        }
                                                        onClick={onAddOffline}
                                                    ></Button>
                                                )}
                                            </Space>
                                        </Form.Item>
                                    )}
                                    {hasOffline && tmtJudge && tmtJudge.length > 0 && (
                                        <Form.Item {...tailLayout} name="relevants">
                                            <List
                                                style={{ marginBottom: 10, background: '#fff' }}
                                                bordered
                                                loading={{
                                                    indicator: <></>,
                                                    spinning: loading
                                                }}
                                                dataSource={tmtJudge}
                                                renderItem={(item: any, index) => (
                                                    <List.Item
                                                        key={item.id}
                                                        actions={[
                                                            <Text
                                                                className="txt_red hand"
                                                                onClick={() => {
                                                                    tmtJudge.splice(index, 1)
                                                                    dispatchR({
                                                                        type: SetTMTJudge,
                                                                        payload: [...tmtJudge],
                                                                    })
                                                                }}
                                                                title={t('delete')}
                                                            >
                                                                <DeleteOutlined style={{ fontSize: 16 }} />
                                                            </Text>,
                                                        ]}
                                                    >
                                                        {item.nickName}
                                                    </List.Item>
                                                )}
                                            />
                                        </Form.Item>
                                    )}
                                </>
                            )}
                            {reviewType === 1 && (
                                <>
                                    <Form.Item
                                        name="technologyCertification"
                                        label={
                                            <span className="label">
                                                {t('technologyCertification')}
                                            </span>
                                        }
                                    >
                                        <Radio.Group
                                            disabled={isRelevantRes}
                                        >
                                            <Radio onClick={() => {
                                                if (techCertification === 1) {
                                                    formRef.current?.setFieldValue('technologyCertification', null)
                                                }
                                            }} value={1}>{t('isDisruptiveResult')}</Radio>
                                            <Radio onClick={() => {
                                                if (techCertification === 2) {
                                                    formRef.current?.setFieldValue('technologyCertification', null)
                                                }
                                            }} value={2}>{t('isCrossResult')}</Radio>
                                        </Radio.Group>
                                    </Form.Item>
                                </>
                            )}
                            {/* 选择Crossbreed时，选择跨域 Work Group */}
                            {techCertification === 2 && (
                                <Form.Item
                                    name="crossBreedWorkGroupId"
                                    label={
                                        <span className="label">
                                            {'Crossbreed' +
                                                (i18n.language !== 'zh' ? ' ' : '') +
                                                t('Work Group')}
                                        </span>
                                    }
                                    rules={[
                                        { required: true, message: t('Work Group Required') },
                                    ]}
                                >
                                    {!isEdit ? (
                                        <Select
                                            allowClear
                                            placeholder={t('Work Group Placeholder')}
                                            onChange={changeCrossWorkgroup}
                                        >
                                            {workgroupList.map((item) => {
                                                return (
                                                    <Option
                                                        key={item.id}
                                                        value={item.id}
                                                        disabled={item.id === selWorkgroup?.id}
                                                    >
                                                        {item.groupName}
                                                    </Option>
                                                )
                                            })}
                                        </Select>
                                    ) : (
                                        formObj?.crossBreedWorkGroupName || ''
                                    )}
                                </Form.Item>
                            )}
                            <Form.Item
                                name="reviewDate"
                                label={
                                    <span className="label">
                                        {
                                            // 第4类 或 第3类(成果交付时，选择第4类也需要显示为截止日期)
                                            (reviewType !== 4
                                                ? reviewType === 3 &&
                                                    ((selectProposal &&
                                                        selectProposal.reviewType === 4) ||
                                                        // 或编辑时 isPlReview 为 true时，也显示截止日期
                                                        formObj?.isPlReview)
                                                    ? t('end')
                                                    : t('reviewMeeting')
                                                : joinTranslatedStrings('PL TMT', t('end'), t('date')))
                                        }
                                    </span>
                                }
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            reviewType !== 4
                                                ? t('reviewMeeting Time Required')
                                                : t('endDate Required'),
                                    },
                                ]}
                            >
                                <Space align="center">
                                    <Form.Item name="reviewDate" className="mb0">
                                        {!isRelevantRes ? (
                                            <DatePicker
                                                allowClear
                                                inputReadOnly
                                                locale={i18n.language === 'zh' ? locale : undefined}
                                                placeholder={
                                                    t('Please Select') +
                                                    (i18n.language !== 'zh' ? ' ' : '') +
                                                    (reviewType !== 4 ? t('reviewMeeting') : t('end')) +
                                                    (i18n.language !== 'zh' ? ' ' : '') +
                                                    t('time')
                                                }
                                                disabledDate={(current) => {
                                                    const now = moment()
                                                    const twoMonthsLater = moment().add(2, 'months')

                                                    if (!selectStartDate) {
                                                        // 如果没有选择开始日期，禁用当前时间之前和2个月后的日期
                                                        return current.isBefore(now.toDate(), 'day') || current.isAfter(twoMonthsLater.toDate(), 'day')
                                                    } else {
                                                        // 如果已选择开始日期，禁用开始日期之前和2个月后的日期
                                                        return current.isBefore(selectStartDate, 'day') || current.isAfter(twoMonthsLater.toDate(), 'day')
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    formRef.current?.setFieldValue('reviewDate', e)
                                                    formRef.current?.validateFields(['reviewDate'])
                                                }}
                                            />
                                        ) : (
                                            formObj?.reviewDate?.format('YYYY-MM-DD') || ''
                                        )}
                                    </Form.Item>
                                    <Text disabled>{t('timeZonePrompt')}</Text>
                                </Space>
                            </Form.Item>
                            {/* 选择成果交付时，如果选择的提案类型为4，也不显示 */}
                            {((reviewType !== 4 && reviewType !== 3) ||
                                (reviewType === 3 &&
                                    // 如果没有信息，并且选的提案类型不为4
                                    ((!formObj &&
                                        (!selectProposal || selectProposal.reviewType !== 4)) ||
                                        // 编辑时，如果提案类型为4 且 isType4Commit 为 false 才显示时间选择器
                                        (formObj && !formObj.isPlReview)))) && (
                                <>
                                    <Form.Item
                                        name="reviewDateHours"
                                        label={
                                            <span className="label">
                                                {t('reviewMeeting') +
                                                        (i18n.language !== 'zh' ? ' ' : '') +
                                                        t('time')}
                                                <Popover
                                                    title={null}
                                                    trigger="hover"
                                                    placement="bottomLeft"
                                                    content={<span>{t('reviewMeetingTimeTips')}</span>}
                                                >
                                                    <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                                                </Popover>
                                            </span>
                                        }
                                        rules={[
                                            {
                                                required: !isRelevantRes,
                                                message: t('reviewMeeting Time Required'),
                                            },
                                        ]}
                                    >
                                        {!isRelevantRes ? (
                                            <Space align="center">
                                                <Form.Item name="reviewDateHours" className="mb0">
                                                    <TimePicker.RangePicker
                                                        allowClear
                                                        inputReadOnly
                                                        format={'HH:mm'}
                                                        minuteStep={10}
                                                        locale={i18n.language === 'zh' ? locale : undefined}
                                                        onChange={(e) => {
                                                            console.log('reviewDateHours: ', e)
                                                            if (e) {
                                                                formRef.current?.setFieldValue(
                                                                    'reviewDateHours',
                                                                    e
                                                                )
                                                                formRef.current?.validateFields([
                                                                    'reviewDateHours',
                                                                ])
                                                            }
                                                        }}
                                                    />
                                                </Form.Item>
                                            </Space>
                                        ) : typeof formObj?.reviewDateHours === 'string' ? (
                                            formObj.reviewDateHours
                                        ) : (
                                            formObj?.reviewDateHours
                                                ?.map((item) => item.format('HH:mm'))
                                                .join('~')
                                        )}
                                    </Form.Item>
                                </>
                            )}
                            {reviewType !== 3 && (
                                <>
                                    {/* 开发责任主体 */}
                                    {reviewType !== 4 && (
                                        <Form.Item
                                            name="dutyBuss"
                                            data-field="dutyBuss"
                                            label={
                                                <span className="label">{t('developDutySubject')}</span>
                                            }
                                            rules={[
                                                {
                                                    required: true,
                                                    validator: async () => {
                                                        if (!dutyBuss || dutyBuss.length === 0) {
                                                            const helpStr =
                                                                t('Please Select') +
                                                                (i18n.language !== 'zh' ? ' ' : '') +
                                                                t('developDutySubject')
                                                            return Promise.reject(new Error(helpStr))
                                                        } else {
                                                            return Promise.resolve()
                                                        }
                                                    },
                                                },
                                            ]}
                                        >
                                            <Input hidden />
                                            {devSubject.length > 0 && (
                                                <List
                                                    style={{ marginBottom: 10, background: '#fff' }}
                                                    bordered
                                                    loading={{
                                                        indicator: <></>,
                                                        spinning: loading
                                                    }}
                                                    dataSource={devSubject}
                                                    renderItem={(item, index) => (
                                                        <List.Item
                                                            key={item.id}
                                                            actions={
                                                                !isRelevantRes
                                                                    ? [
                                                                        <Text
                                                                            className="txt_red hand"
                                                                            title={t('delete')}
                                                                            key={'devSubject' + index}
                                                                            onClick={() => {
                                                                                const newDutyBuss = [...devSubject]
                                                                                newDutyBuss.splice(index, 1)
                                                                                setDevSubject(newDutyBuss)
                                                                                form.setFieldValue('dutyBuss', newDutyBuss.map(i => i.id))
                                                                                form.validateFields([
                                                                                    'dutyBuss',
                                                                                ])
                                                                            }}
                                                                        >
                                                                            <DeleteOutlined
                                                                                style={{ fontSize: 16 }}
                                                                            />
                                                                        </Text>,
                                                                    ]
                                                                    : []
                                                            }
                                                        >
                                                            {item.bu}
                                                        </List.Item>
                                                    )}
                                                />
                                            )}
                                            {!isRelevantRes && (
                                                <Button
                                                    onClick={() => {
                                                        setCurSelectType('devSubject')
                                                        setShowSelectBu(true)
                                                    }}
                                                >
                                                    {t('Please Select') +
                                                        (i18n.language !== 'zh' ? ' ' : '') +
                                                        t('buAndCtList')}
                                                </Button>
                                            )}
                                        </Form.Item>
                                    )}
                                    {/* BU/Div清单 */}
                                    <Form.Item
                                        name="costBuss"
                                        data-field="costBuss"
                                        label={
                                            <span className="label">
                                                {/* BU TMT批准技术课题 时显示 提案归属业务模块 */}
                                                {reviewType !== 4
                                                    ? t('developCostAttribute')
                                                    : t('proposalAttributionBusinessModule')}
                                                {reviewType !== 4 && (
                                                    <Popover
                                                        title={null}
                                                        trigger="hover"
                                                        placement="bottomLeft"
                                                        content={<span>{t('relativeBUTips')}</span>}
                                                    >
                                                        <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                                                    </Popover>
                                                )}
                                            </span>
                                        }
                                        rules={[
                                            {
                                                required: true,
                                                validator: async () => {
                                                    // BU TMT批准技术课题 时显示 提案归属业务模块
                                                    if (!costBuss || costBuss.length === 0) {
                                                        const helpStr =
                                                            t('Please Select') +
                                                            (i18n.language !== 'zh' ? ' ' : '') +
                                                            (reviewType !== 4
                                                                ? t('developCostAttribute')
                                                                : t('proposalAttributionBusinessModule'))
                                                        return Promise.reject(new Error(helpStr))
                                                    } else {
                                                        return Promise.resolve()
                                                    }
                                                },
                                            },
                                        ]}
                                    >
                                        <Input hidden />
                                        {devCostAttr.length > 0 && (
                                            <List
                                                style={{ marginBottom: 10, background: '#fff' }}
                                                bordered
                                                loading={{
                                                    indicator: <></>,
                                                    spinning: loading
                                                }}
                                                dataSource={devCostAttr}
                                                renderItem={(item, index) => (
                                                    <List.Item
                                                        key={item.id}
                                                        actions={
                                                            !isRelevantRes
                                                                ? [
                                                                    <Text
                                                                        className="txt_red hand"
                                                                        title={t('delete')}
                                                                        key={'devCostAttr' + index}
                                                                        onClick={() => {
                                                                            devCostAttr.splice(index, 1)
                                                                            setDevCostAttr([...devCostAttr])
                                                                            form.setFieldValue('costBuss', devCostAttr.map(i => i.id))
                                                                            form.validateFields([
                                                                                'costBuss',
                                                                            ])
                                                                        }}
                                                                    >
                                                                        <DeleteOutlined
                                                                            style={{ fontSize: 16 }}
                                                                        />
                                                                    </Text>,
                                                                ]
                                                                : []
                                                        }
                                                    >
                                                        {item.bu}
                                                    </List.Item>
                                                )}
                                            />
                                        )}
                                        {!isRelevantRes && (
                                            <Button
                                                onClick={() => {
                                                    setCurSelectType('devCostAttr')
                                                    setShowSelectBu2(true)
                                                }}
                                            >
                                                {/* BU TMT批准技术课题 时显示 提案归属业务模块 */}
                                                {t('Please Select') +
                                                    (i18n.language !== 'zh' ? ' ' : '') +
                                                    (reviewType !== 4
                                                        ? t('buAndCtList')
                                                        : t('proposalAttributionBusinessModule'))}
                                            </Button>
                                        )}
                                    </Form.Item>
                                </>
                            )}
                            {/* 业务相关责任人 */}
                            {reviewType === 4 && (
                                <>
                                    <Form.Item
                                        name="parentTech"
                                        label={
                                            <span className="label">
                                                {t('higherLevelTechnicalPoints')}
                                                <Popover
                                                    title={null}
                                                    trigger="hover"
                                                    placement="bottomLeft"
                                                    content={<span>{t('prompt9')}</span>}
                                                >
                                                    <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                                                </Popover>
                                            </span>
                                        }
                                    >
                                        {!isEdit ? (
                                            <NoSpaceInput
                                                allowClear
                                                placeholder={
                                                    t('Please Input') +
                                                    (i18n.language !== 'zh' ? ' ' : '') +
                                                    t('higherLevelTechnicalPoints')
                                                }
                                            />
                                        ) : (
                                            formObj?.parentTech
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        name="productFunction"
                                        label={
                                            <span className="label">
                                                {t('productFeatures')}({t('USP')})
                                                <Popover
                                                    title={null}
                                                    trigger="hover"
                                                    placement="bottomLeft"
                                                    content={<span>{t('prompt10')}</span>}
                                                >
                                                    <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                                                </Popover>
                                            </span>
                                        }
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    t('Please Input') +
                                                    (i18n.language !== 'zh' ? ' ' : '') +
                                                    t('productFeatures'),
                                            },
                                        ]}
                                    >
                                        {
                                            <NoSpaceInput
                                                allowClear
                                                placeholder={
                                                    t('Please Input') +
                                                    (i18n.language !== 'zh' ? ' ' : '') +
                                                    t('productFeatures')
                                                }
                                            />
                                        }
                                        {/* {!isEdit ? (
                                    <NoSpaceInput allowClear placeholder={t('Please Input') + (i18n.language !== 'zh' ? ' ' : '')
                                        + t('productFeatures')} />
                                ) : formObj?.productFunction} */}
                                    </Form.Item>
                                    <Form.Item
                                        name="techScope"
                                        label={
                                            <span className="label">
                                                {t('technicalApplicationRange')}
                                                <Popover
                                                    title={null}
                                                    trigger="hover"
                                                    placement="bottomLeft"
                                                    content={<span>{t('prompt11')}</span>}
                                                >
                                                    <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                                                </Popover>
                                            </span>
                                        }
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    t('Please Input') +
                                                    (i18n.language !== 'zh' ? ' ' : '') +
                                                    t('technicalApplicationRange'),
                                            },
                                        ]}
                                    >
                                        {
                                            <NoSpaceInput
                                                allowClear
                                                placeholder={
                                                    t('Please Input') +
                                                    (i18n.language !== 'zh' ? ' ' : '') +
                                                    t('technicalApplicationRange')
                                                }
                                            />
                                        }
                                        {/* {!isEdit ? (
                                    <NoSpaceInput allowClear placeholder={t('Please Input') + (i18n.language !== 'zh' ? ' ' : '')
                                        + t('technicalApplicationRange')} />
                                ) : formObj?.techScope} */}
                                    </Form.Item>
                                    <Form.Item
                                        name="techPerformance"
                                        label={
                                            <span className="label">
                                                {t('technicalPerformanceIndicators')}
                                                <Popover
                                                    title={null}
                                                    trigger="hover"
                                                    placement="bottomLeft"
                                                    content={<span>{t('prompt12')}</span>}
                                                >
                                                    <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                                                </Popover>
                                            </span>
                                        }
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    t('Please Input') +
                                                    (i18n.language !== 'zh' ? ' ' : '') +
                                                    t('technicalPerformanceIndicators'),
                                            },
                                        ]}
                                    >
                                        {
                                            <NoSpaceInput
                                                allowClear
                                                placeholder={
                                                    t('Please Input') +
                                                    (i18n.language !== 'zh' ? ' ' : '') +
                                                    t('technicalPerformanceIndicators')
                                                }
                                            />
                                        }
                                        {/* {!isEdit ? (
                                    <NoSpaceInput allowClear placeholder={t('Please Input') + (i18n.language !== 'zh' ? ' ' : '')
                                        + t('technicalPerformanceIndicators')} />
                                ) : formObj?.techPerformance} */}
                                    </Form.Item>
                                    <Form.Item
                                        name="techSource"
                                        label={
                                            <span className="label">
                                                {t('technicalOrigin')}
                                                <Popover
                                                    title={null}
                                                    trigger="hover"
                                                    placement="bottomLeft"
                                                    content={<span>{t('prompt13')}</span>}
                                                >
                                                    <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                                                </Popover>
                                            </span>
                                        }
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    t('Please Input') +
                                                    (i18n.language !== 'zh' ? ' ' : '') +
                                                    t('technicalOrigin'),
                                            },
                                        ]}
                                    >
                                        {!isEdit ? (
                                            <Select
                                                placeholder={
                                                    t('Please Select') +
                                                    (i18n.language !== 'zh' ? ' ' : '') +
                                                    t('technicalOrigin')
                                                }
                                                options={[
                                                    {
                                                        value: 1,
                                                        label: t('independentIP'),
                                                    },
                                                    {
                                                        value: 2,
                                                        label: t('outsourcedTechnology'),
                                                    },
                                                    {
                                                        value: 3,
                                                        label: t('coDevelopedTechnology'),
                                                    },
                                                ]}
                                            />
                                        ) : (
                                            // <NoSpaceInput allowClear placeholder={t('Please Input') + (i18n.language !== 'zh' ? ' ' : '')
                                            //     + t('technicalOrigin')} />
                                            formObj?.techSource
                                        )}
                                    </Form.Item>
                                    <Form.Item
                                        name="firstUseDate"
                                        label={
                                            <span className="label">
                                                {t('estimatedFirstApplicationTime')}
                                                <Popover
                                                    title={null}
                                                    trigger="hover"
                                                    placement="bottomLeft"
                                                    content={<span>{t('prompt14')}</span>}
                                                >
                                                    <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                                                </Popover>
                                            </span>
                                        }
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    t('Please Select') +
                                                    (i18n.language !== 'zh' ? ' ' : '') +
                                                    t('estimatedFirstApplicationTime'),
                                            },
                                        ]}
                                    >
                                        {
                                            <DatePicker
                                                allowClear
                                                inputReadOnly
                                                locale={i18n.language === 'zh' ? locale : undefined}
                                                placeholder={t('estimatedFirstApplicationTime')}
                                            />
                                        }
                                        {/* {!isEdit ? <DatePicker allowClear inputReadOnly
                                    locale={i18n.language === 'zh' ? locale : undefined}
                                    placeholder={t('estimatedFirstApplicationTime')}
                                /> : formObj?.firstUseDate} */}
                                    </Form.Item>
                                </>
                            )}
                            <Form.Item
                                name="fileIds"
                                data-field="fileIds"
                                label={
                                    <span className="label">
                                        {approvalType[(reviewType || 1) - 1].label +
                                            (i18n.language !== 'zh' ? ' ' : '') +
                                            t('attach')}
                                    </span>
                                }
                                rules={[
                                    {
                                        required: true,
                                        validator: async () => {
                                            if (fileIds.length === 0) {
                                                const helpStr = t('attach Required')
                                                return Promise.reject(new Error(helpStr))
                                            } else {
                                                return Promise.resolve()
                                            }
                                        },
                                    },
                                ]}
                            >
                                <Input hidden />
                                <Upload {...props} disabled={uploading}>
                                    <Button icon={<UploadOutlined />} loading={uploading}>
                                        {t('uploadFile')}
                                    </Button>
                                </Upload>
                            </Form.Item>
                            <Form.Item
                                name="description"
                                label={
                                    <span className="label">
                                        {approvalType[(reviewType || 1) - 1].label +
                                            (i18n.language !== 'zh' ? ' ' : '') +
                                            t('proposalSummary')}
                                    </span>
                                }
                                rules={[
                                    {
                                        required: true,
                                        validator: async (_rule, value) => {
                                            const currentValue = value || [
                                                {
                                                    type: 'paragraph',
                                                    children: [{ text: '' }],
                                                },
                                            ]
                                            // 去掉前后空格
                                            const editorHtmlValue = editorRef?.current?.serialize({
                                                children: serialize(handleTrim(currentValue)),
                                            })
                                            // 获取去掉html后的纯文本并去除空格
                                            let word = editorHtmlValue?.replace(/<[^>]*>/g, '').trim()
                                            console.log('word before removing default text: ', word)

                                            // 去除默认提示文本
                                            const defaultTexts = [
                                                '背景（选填）：',
                                                '需求（选填）：',
                                                '目标（选填）：',
                                                '背景：',
                                                '功能描述：',
                                                '验收指标：'
                                            ]

                                            // 逐一去除默认提示文本
                                            defaultTexts.forEach(defaultText => {
                                                word = word?.replace(new RegExp(defaultText, 'g'), '')
                                            })

                                            // 再次去除空格和换行符
                                            word = word?.trim()
                                            console.log('word after removing default text: ', word)

                                            // 检查是否为空内容
                                            if (!word || word.length === 0) {
                                                const helpStr =
                                                    t('Please Input') +
                                                    (i18n.language !== 'zh' ? ' ' : '') +
                                                    approvalType[(reviewType || 1) - 1].label +
                                                    (i18n.language !== 'zh' ? ' ' : '') +
                                                    t('proposalSummary')
                                                return Promise.reject(new Error(helpStr))
                                            }

                                            // 检查最小长度
                                            let voliLen = 37
                                            const reviewTypeVal = formRef.current?.getFieldValue('reviewType')
                                            console.log('reviewTypeVal: ', reviewTypeVal)
                                            switch (reviewTypeVal) {
                                                case 1:
                                                    break
                                                case 2:
                                                    break
                                                case 3:
                                                    voliLen = 41
                                                    break
                                                case 4:
                                                    break
                                                default:
                                                    voliLen = 10
                                            }
                                            const errorStr = `${t('minLenError')} ${voliLen} ${t(
                                                'lenCharError'
                                            )}`

                                            if (word.length < voliLen) {
                                                return Promise.reject(new Error(errorStr))
                                            } else {
                                                return Promise.resolve()
                                            }
                                        },
                                    },
                                ]}
                            >
                                <Input hidden />
                                <ConfigProvider
                                    value={{
                                        ...defaultConfig,
                                        plugins: [
                                            ...Object.values({
                                                ...plugs,
                                            }),
                                        ],
                                    }}
                                >
                                    <DSlate
                                        ref={editorRef}
                                        key={editorKey}
                                        value={descriptionValue}
                                        onChange={(value: any) => {
                                            form.setFieldValue('description', value)
                                        }}
                                    />
                                </ConfigProvider>
                            </Form.Item>
                            {formObj?.id && (
                                <>
                                    <Form.Item
                                        name="tmtReviewDueDate"
                                        label={<span className="label">{t('feedDueDate')}</span>}
                                        valuePropName="checked"
                                    >
                                        {formObj?.tmtReviewDueDate}
                                    </Form.Item>
                                    <Form.Item
                                        name="dueDate"
                                        label={<span className="label">{t('feedEndDate')}</span>}
                                        valuePropName="checked"
                                    >
                                        {formObj?.dueDate}
                                    </Form.Item>
                                </>
                            )}
                        </>
                    )}
                    {/* 技术规划不显示 技术领先性、技术贡献性、技术类型 */}
                    {isCommunicate && reviewType !== 1 && (
                        <>
                            <hr style={{ marginBottom: 20, borderColor: '#fff' }} />
                            <div style={{ textAlign: 'center' }}>
                                <p style={{ fontSize: 16, fontWeight: 600, marginBottom: 10 }}>
                                    {t('selfEvaluation')}
                                </p>
                            </div>
                            <Form.Item label=" " colon={false}>
                                <Image src={TechReviewImg} />
                            </Form.Item>
                            <Form.Item
                                name="technologyLeadership"
                                label={
                                    <span className="label">
                                        {t('technologicalLeadership')}
                                        <Popover
                                            placement="topLeft"
                                            title=""
                                            content={
                                                <div
                                                    style={{
                                                        maxWidth: 240,
                                                        maxHeight: 300,
                                                        overflowY: 'auto',
                                                        lineHeight: 1.5,
                                                    }}
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            `<h4><b>${t('prompt1')}</b></h4><p>${t(
                                                                'prompt2'
                                                            )}</p>` + `<p>${t('prompt3')}</p>`,
                                                    }}
                                                ></div>
                                            }
                                        >
                                            <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                                        </Popover>
                                    </span>
                                }
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            t('Please Select') +
                                            (i18n.language !== 'zh' ? ' ' : '') +
                                            t('technologicalLeadership'),
                                    },
                                ]}
                            >
                                <Select
                                    allowClear
                                    placeholder={
                                        t('Please Select') +
                                        (i18n.language !== 'zh' ? ' ' : '') +
                                        t('technologicalLeadership')
                                    }
                                    onChange={() => onChangeSelect()}
                                >
                                    {technologicalLeadershipArr.current.map((item) => {
                                        return (
                                            <Option key={item.id} value={item.id}>
                                                {item.label}
                                            </Option>
                                        )
                                    })}
                                </Select>
                            </Form.Item>
                            <Form.Item
                                name="technologyContribution"
                                label={
                                    <span className="label">
                                        {t('technicalContribution')}
                                        <Popover
                                            placement="topLeft"
                                            title=""
                                            content={
                                                <div
                                                    style={{
                                                        maxWidth: 240,
                                                        maxHeight: 300,
                                                        overflowY: 'auto',
                                                        lineHeight: 1.5,
                                                    }}
                                                    dangerouslySetInnerHTML={{
                                                        __html:
                                                            `<h4><b>${t('prompt4')}</b></h4>` +
                                                            `<p>${t('prompt5')}</p><p>${t('prompt6')}</p>` +
                                                            `<h4 style='margin-top: 10px;'><b>${t(
                                                                'prompt7'
                                                            )}</b></h3>` +
                                                            `<p>${t('prompt8')}</p>`,
                                                    }}
                                                ></div>
                                            }
                                        >
                                            <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                                        </Popover>
                                    </span>
                                }
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            t('Please Select') +
                                            (i18n.language !== 'zh' ? ' ' : '') +
                                            t('technicalContribution'),
                                    },
                                ]}
                            >
                                <Select
                                    allowClear
                                    placeholder={
                                        t('Please Select') +
                                        (i18n.language !== 'zh' ? ' ' : '') +
                                        t('technicalContribution')
                                    }
                                    onChange={() => onChangeSelect()}
                                >
                                    {technicalContributionArr.current.map((item) => {
                                        return (
                                            <Option key={item.id} value={item.id}>
                                                {item.label}
                                            </Option>
                                        )
                                    })}
                                </Select>
                            </Form.Item>
                            <Form.Item shouldUpdate noStyle>
                                {({ getFieldValue }) => {
                                    const value = getFieldValue('coreTechnology')
                                    return (
                                        <Form.Item name="coreTechnology" label={t('techType')}>
                                            {
                                                [
                                                    t('core') +
                                                    (i18n.language !== 'zh' ? ' ' : '') +
                                                    t('technology'),
                                                    t('key') +
                                                    (i18n.language !== 'zh' ? ' ' : '') +
                                                    t('technology'),
                                                    t('basicTechnology'),
                                                    t('reserveTechnology'),
                                                ][value]
                                            }
                                        </Form.Item>
                                    )
                                }}
                            </Form.Item>
                            {isCoreOrKey && (
                                <>
                                    <hr style={{ marginBottom: 20, borderColor: '#fff' }} />
                                    <Form.Item
                                        name="standardName"
                                        label={<span className="label">{t('standardName')}</span>}
                                    // rules={[{
                                    //     required: true,
                                    //     message: t('Please Input') + (i18n.language !== 'zh' ? ' ' : '') + t('standardName')
                                    // }]}
                                    >
                                        <NoSpaceInput
                                            allowClear
                                            placeholder={
                                                t('Please Input') +
                                                (i18n.language !== 'zh' ? ' ' : '') +
                                                t('standardName')
                                            }
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="standardOutput"
                                        label={<span className="label">{t('standardOutput')}</span>}
                                        rules={[
                                            {
                                                // required: true,
                                                // validator: async () => {
                                                //     if (JSON.stringify(standardOutputValue) === '[{"type":"paragraph","children":[{"text":""}]}]') {
                                                //         const helpStr = t('Please Input') + (i18n.language !== 'zh' ? ' ' : '') +
                                                //             approvalType[(reviewType || 1) - 1].label + (i18n.language !== 'zh' ? ' ' : '') + t('standardOut')
                                                //         return Promise.reject(new Error(helpStr))
                                                //     } else {
                                                //         // 去掉前后空格
                                                //         const editorHtmlValue = editor2Ref?.current?.serialize({ children: serialize(handleTrim(standardOutputValue)) })
                                                //         // 获取去掉html后的纯文本
                                                //         const word = editorHtmlValue?.replace(/<[^>]*>/g, '')
                                                //         console.log('word: ', word)
                                                //         //const errorStr = `${t('minLenError')} 10 ${t('lenCharError')}`
                                                //         let voliLen = 37
                                                //         const reviewTypeVal = formRef.current?.getFieldValue('reviewType')
                                                //         console.log('reviewTypeVal: ', reviewTypeVal)
                                                //         switch (reviewTypeVal) {
                                                //             case 1:
                                                //                 break
                                                //             case 2:
                                                //                 break
                                                //             case 3:
                                                //                 voliLen = 41
                                                //                 break
                                                //             case 4:
                                                //                 break
                                                //             default:
                                                //                 voliLen = 10
                                                //         }
                                                //         const errorStr = `${t('minLenError')} ${voliLen} ${t('lenCharError')}`
                                                //         if (word) {
                                                //             if (word.length < voliLen) {
                                                //                 return Promise.reject(new Error(errorStr))
                                                //             } else {
                                                //                 return Promise.resolve()
                                                //             }
                                                //         } else {
                                                //             return Promise.reject(new Error(errorStr))
                                                //         }
                                                //     }
                                                // }
                                            },
                                        ]}
                                    >
                                        <Input hidden />
                                        <ConfigProvider
                                            value={{
                                                ...defaultConfig,
                                                plugins: [
                                                    ...Object.values({
                                                        ...plugs,
                                                    }),
                                                ],
                                            }}
                                        >
                                            <DSlate
                                                ref={editor2Ref}
                                                key={editor1Key}
                                                value={standardOutputValue}
                                                onChange={setStandardOutputValue}
                                            />
                                        </ConfigProvider>
                                    </Form.Item>
                                </>
                            )}
                            {/* <hr style={{ marginBottom: 20, borderColor: '#fff' }} /> */}
                            {isCoreOrKey && reviewType === 3 && (
                                <>
                                    <Form.Item
                                        name="standardNumber"
                                        label={
                                            <span className="label">
                                                {t('standardNumber')}
                                                <Popover
                                                    placement="topLeft"
                                                    title=""
                                                    content={
                                                        <div
                                                            style={{
                                                                maxWidth: 250,
                                                                maxHeight: 300,
                                                                overflowY: 'auto',
                                                                lineHeight: 1.5,
                                                                wordWrap: 'break-word', // Ensure text wraps when it reaches the container's boundary
                                                                whiteSpace: 'normal', // Allow the text to wrap to the next line
                                                            }}
                                                        >
                                                            <span>
                                                                <p>
                                                                    {t('eIAo3QeU1hOGdHiSzoBL9')}
                                                                </p>
                                                                <p>
                                                                    {t('iGRhaGtY4pEM3c80tRT8x')}
                                                                    <a
                                                                        href="https://yesv-desaysv.feishu.cn/docx/IaMDdkN3potqSOxLSqLch5SInrv"
                                                                        target="black"
                                                                    >
                                                                        {t('MxT68XWPZEsBkadGjmcC5')}
                                                                    </a>
                                                                </p>
                                                            </span>
                                                        </div>
                                                    }
                                                >
                                                    <QuestionCircleOutlined style={{ marginLeft: 5 }} />
                                                </Popover>
                                            </span>
                                        }
                                    // rules={[{
                                    //     required: true,
                                    //     message: t('Please Input') + (i18n.language !== 'zh' ? ' ' : '') + t('standardNumber')
                                    // }]}
                                    >
                                        <NoSpaceInput
                                            allowClear
                                            placeholder={
                                                t('Please Input') +
                                                (i18n.language !== 'zh' ? ' ' : '') +
                                                t('standardNumber')
                                            }
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="standardLink"
                                        label={<span className="label">{t('standardLink')}</span>}
                                    // rules={[{
                                    //     required: true,
                                    //     message: t('Please Input') + (i18n.language !== 'zh' ? ' ' : '') + t('standardLink')
                                    // }]}
                                    >
                                        <NoSpaceInput
                                            allowClear
                                            placeholder={
                                                t('Please Input') +
                                                (i18n.language !== 'zh' ? ' ' : '') +
                                                t('standardLink')
                                            }
                                        />
                                    </Form.Item>
                                </>
                            )}
                        </>
                    )}
                    {/* 成果交付需要选择 技术领头人、核心成员、一般成员 */}
                    {isCommunicate && reviewType === 3 && (
                        <>
                            <Form.Item
                                name="techLeaders"
                                label={<span className="label">{t('techLeaders')}</span>}
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            t('Please Select') +
                                            (i18n.language !== 'zh' ? ' ' : '') +
                                            t('techLeaders'),
                                    },
                                ]}
                            >
                                <SelectUserOfIdName
                                    mode="multiple"
                                    placeholder={
                                        t('Please Select') +
                                        (i18n.language !== 'zh' ? ' ' : '') +
                                        t('techLeaders') +
                                        ', ' +
                                        t('organPersonTips')
                                    }
                                    onChange={(val: any) => onChangeLeader(val, 'techLeaders')}
                                />
                            </Form.Item>
                            <Form.Item
                                name="coreMembers"
                                label={<span className="label">{t('coreMembers')}</span>}
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            t('Please Select') +
                                            (i18n.language !== 'zh' ? ' ' : '') +
                                            t('coreMembers'),
                                    },
                                ]}
                            >
                                <SelectUserOfIdName
                                    mode="multiple"
                                    placeholder={
                                        t('Please Select') +
                                        (i18n.language !== 'zh' ? ' ' : '') +
                                        t('coreMembers') +
                                        ', ' +
                                        t('organPersonTips')
                                    }
                                    onChange={(val: any) => onChangeLeader(val, 'coreMembers')}
                                />
                            </Form.Item>
                            <Form.Item
                                name="generalMembers"
                                label={<span className="label">{t('generalMembers')}</span>}
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            t('Please Select') +
                                            (i18n.language !== 'zh' ? ' ' : '') +
                                            t('generalMembers'),
                                    },
                                ]}
                            >
                                <SelectUserOfIdName
                                    mode="multiple"
                                    placeholder={
                                        t('Please Select') +
                                        (i18n.language !== 'zh' ? ' ' : '') +
                                        t('generalMembers') +
                                        ', ' +
                                        t('organPersonTips')
                                    }
                                    onChange={(val: any) => onChangeLeader(val, 'generalMembers')}
                                />
                            </Form.Item>
                        </>
                    )}
                    <Form.Item {...tailLayout} style={{ textAlign: 'center' }}>
                        <Space size={20}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={loading}
                                disabled={!isCommunicate}
                            >
                                {t('submit')}
                            </Button>
                            {!formObj && (
                                <Button htmlType="button" onClick={onReset}>
                                    {t('reset')}
                                </Button>
                            )}
                        </Space>
                    </Form.Item>
                </Form>
            ) : (
                <div
                    style={{
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Spin size="large" />
                </div>
            )}
            {/* 开发责任主体 */}
            <SelectBU
                show={showSelectBu}
                selectedKeysData={devSubject.map((item) => item.id.toString())}
                setShow={setShowSelectBu}
                title={
                    t('select') + (i18n.language !== 'zh' ? ' ' : '') + t('buAndCtList')
                }
                confirm={selectBuCallback}
            />
            {/* BU/Div清单 */}
            {/* BU TMT批准技术课题 时显示 提案归属业务模块 */}
            <SelectBU
                show={showSelectBu2}
                selectedKeysData={devCostAttr.map((item) => item.id.toString())}
                setShow={setShowSelectBu2}
                title={
                    t('select') +
                    (i18n.language !== 'zh' ? ' ' : '') +
                    (reviewType !== 4
                        ? t('buAndCtList')
                        : t('proposalAttributionBusinessModule'))
                }
                confirm={selectBuCallback}
            />
            {/* 业务相关责任人 */}
            <SelectRelatedResponsible
                show={showSelectPerson}
                setShow={setShowSelectPerson}
                title={
                    t('select') +
                    (i18n.language !== 'zh' ? ' ' : '') +
                    t('businessRelatedResponsiblePersons')
                }
                orgRole={RoleCont.PLTMTLeader}
                confirm={selectPersonCallback}
            />
            {/* 选择提案 */}
            <SelectProposalListPop
                show={stateR.showSelectProposalPop}
                hide={onHideSelectProposalListPop}
                selectedKeys={selectProposal?.id ? [selectProposal.id] : undefined}
            />
            {/* 选择课题 */}
            <SelectTechListPop
                show={stateR.showSelectTechListPop}
                hide={onHideSelectTechListPop}
                checked
                selectionKey={selectionKey}
                setSelectionKey={setSelectionKey}
                selectRecord={selectRecord}
                setSelectRecord={setSelectRecord}
                maturityStatus
                addTechReview
            />
            <SelectUser
                show={showSelectUser}
                setShow={setShowSelectUser}
                title={t('selectTmtUser')}
                isRelevant={true}
                confirm={selectUserCallback}
            />
        </Space>
    )
}
export default AddTechReview
